// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__11pjT","question":"Question_question__D4l_B","description":"Question_description__3AFpX"};